module.exports = __webpack_public_path__ + "img/completed_status.36faa5af.svg";